import React, { FC } from 'react'
import Grid from '@mui/material/Grid'
import { useFormik, FormikProvider, Form } from 'formik'
import { useProjectListRequest } from 'src/hooks/api'
import { useQueryParams } from 'src/hooks/ui'
import { SearchParamsKeys } from 'src/enums'
import { DataLoad, HideArchivedProjectsFilter } from 'src/components'
import { NewProjectList } from 'src/components/sections/project/newProjectList'

interface ContractorProjectsProps {
  contractorId: number;
}

export const ContractorProjects: FC<ContractorProjectsProps> = ({
  contractorId,
}) => {
  const [queryParams, setQueryParams] = useQueryParams()
  const { isInitialLoading, isError, error, data } = useProjectListRequest({
    params: {
      contractorId,
      ...queryParams,
    },
  })

  const formik = useFormik({
    initialValues: {
      [SearchParamsKeys.HideArchivedProjects]: queryParams[SearchParamsKeys.HideArchivedProjects] || undefined,
    },
    onSubmit: async (formState) => {},
  })
  return (
    <Grid container flexDirection="column" spacing={2} wrap="nowrap">
      <Grid item>
        <FormikProvider value={formik}>
          <Form>
            <HideArchivedProjectsFilter />
          </Form>
        </FormikProvider>
      </Grid>
      <Grid item minWidth={0}>
        <DataLoad isLoading={false} isError={isError} errorMessage={error?.message}>
          <NewProjectList
            isLoading={isInitialLoading}
            data={data?.rows || []}
            count={data?.count || 0}
            queryParams={queryParams}
            setQueryParams={setQueryParams}
            autoHeight
          />
        </DataLoad>
      </Grid>
    </Grid>
  )
}
